/* eslint-disable eqeqeq */
import { FC, useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";

import { withProcedureWraper } from "../..";
import { Routes } from "../../../../AppRoutes";
import { Box } from "../../../../components/box";
import { InputArrayData, InputText, InputSelect, InputNumber } from "../../../../components/input";
import { Button } from "../../../../modules/button";
import { InputWraper, useForm } from "../../../../modules/form";
import { useSelector } from "../../../../store/store";
import { CreateNotification } from "../../../../components/notifier";
import { Icon } from "../../../../components/icon";
import { MailService } from "../../../../services/mail/mail.service";
import { codeProcessRequestTypes } from "../../info-technology-process/code-process/codeRequestType";
import { UserSelect } from "../../../../components/input/select/UserSelect";

import { getEnv, isDev } from "../../../../AppConfigs";
import { mailRegexs } from "../../../../constants/mailTemplateConstants";
import { requestStatus } from "../../../../constants/statusConstants";

import { Col, Row } from "react-bootstrap";
import { department, unitDN, unitNB, unitTSN } from "../../info-technology-process/data";
import { getDDMMYYYFormat, getHHmmFormat } from "../../../../helper/dateTimeHelper";
import { PeoplePicker, PersonType } from "@microsoft/mgt-react";
import { VehicleContentForm, VehicleContentStructure } from "./formRequestVehicle";
import { VehicleRequestService } from "../../../../services/company-office/VehicleRequestService";
import { validatePhoneNumber, validateRequests } from "../../../../services/util";
import { Upload } from "../../upload";
import { eApproveTitleCode } from "../../../../constants/bizTitle";

const siteUrl = getEnv("REACT_APP_APPROVER_BUSINESS_VEHICLE_REQUEST_URL");

export const createOfficialVehiclePage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const params = useRouteMatch().params as any;
  const id = +params.id;
  const employees = useSelector((state: any) => state.employee.employees);
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  // set State input field
  const [selectedDepartment, setSelectedDepartment] = useState(null as any);
  const [selectedUnit, setSelectedUnit] = useState(null as any);
  const [unit, setUnit] = useState<any>([]);

  const [approverOptions, setApproverOptions] = useState([]);
  const [approver, setApprover] = useState("");
  const [requestType, setRequestType] = useState(codeProcessRequestTypes[0].value);
  const [pickedUserName, setPickedUserName] = useState(null as any);

  const { getInputProps, handleSubmit, isSubmitting, setValues } = useForm({
    structure: [
      {
        name: "deparment",
        label: "Cơ quan/ Đơn vị",
      },
      {
        name: "unit",
        label: "Đơn vị",
      },
      {
        name: "phoneNumber",
        label: "SĐT liên hệ",
      },
      {
        name: "description",
        label: "Lý do",
      },
      {
        name: "requests",
        label: "Đề nghị sử dụng xe công vụ theo chi tiết",
        defaultValue: [],
      },
      {
        name: "fileRequests",
        label: "Tệp đính kèm",
        defaultValue: [],
      },
      {
        name: "pickApprover",
        label: "Người duyệt",
      },
      {
        name: "findApprover",
        label: "Người duyệt thay thế",
      },
    ],
    onSubmit: async (payload) => {
      const { requests, fileRequests, phoneNumber, description } = payload;
      if (!phoneNumber) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập SĐT liên hệ!",
          icon: "/icons/warning.png",
        });
        return;
      }

      const formattedValue = phoneNumber.toString().padStart(10, "0");

      if (!validatePhoneNumber(formattedValue)) {
        CreateNotification({
          title: "Thông báo",
          body: "Số điện thoại không hợp lệ!",
          icon: "/icons/warning.png",
        });
        return;
      }

      if (!description) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập lý do",
          icon: "/icons/warning.png",
        });
        return;
      }

      if (requests.length == 0) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      }

      /**
       * Validate data of requests is valid ??
       */
      if (requests.length) {
        const isValidateAllRequests = validateRequests(requests);

        if (!isValidateAllRequests) {
          CreateNotification({
            title: "Thông báo",
            body: "Đề nghị sử dụng xe công vụ theo chi tiết chứa dữ liệu không hợp lệ!",
            icon: "/icons/warning.png",
          });
          return;
        }
      }

      if (!approver && id === 0) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng chọn thủ trưởng CQ/ĐV!",
          icon: "/icons/warning.png",
        });
        return;
      }

      const approverTmp = employees.find((f: any) => f.eMail === approver);
      const software: any = softwares.find((f: any) => f.eSystemCode === "VHR");
      const assignees = software.eITStaff;
      const officialVehicleRequest: any =
        id === 0
          ? {
              fields: {
                Title: `Cấp vé sử dụng xe công vụ`,
                eApprovedBy: approverTmp
                  ? `${approverTmp.eMail}|${approverTmp.Title}`
                  : `${approver}|${pickedUserName}`,
                eApprovedByITLead: `${software.eITTeamLead}|${software.eTeamLeadName}`,
                eApprovedByITHead: `${software.eITHead}|${software.eITHeadName}`,
                eAssignee: assignees,
                eDescription: description,
                eRequestStatus: requestStatus.submitted,
                eRequestType: requestType,
                eContent: JSON.stringify(requests),
                eFileContent: JSON.stringify(fileRequests),
                eDepartment: id === 0 ? selectedDepartment.value : selectedDepartment,
                eUnit: id === 0 ? selectedUnit.value : selectedUnit,
                ePhoneNumber: formattedValue,
              },
            }
          : {
              fields: {
                // Title: `Cấp vé sử dụng xe công vụ`,
                // eApprovedBy: approverTmp
                //   ? `${approverTmp.eMail}|${approverTmp.Title}`
                //   : `${approver}|${pickedUserName}`,
                // eApprovedByITLead: `${software.eITTeamLead}|${software.eTeamLeadName}`,
                // eApprovedByITHead: `${software.eITHead}|${software.eITHeadName}`,
                // eAssignee: assignees,
                eDescription: description,
                // eRequestStatus: requestStatus.submitted,
                eRequestType: requestType,
                eContent: JSON.stringify(requests),
                eFileContent: JSON.stringify(fileRequests),
                // eDepartment: id === 0 ? selectedDepartment.value : selectedDepartment,
                // eUnit: id === 0 ? selectedUnit.value : selectedUnit,
                ePhoneNumber: formattedValue,
              },
            };
      addVehicleRequest(officialVehicleRequest);
    },
  });

  const sendMail = async (approver: any, vehicleRequest: any) => {
    const url = siteUrl + "/details/" + vehicleRequest.id;
    const arr = approver.split("|");
    const tomail = arr.length > 0 ? arr[0] : "";
    const name = arr.length > 1 ? arr[1] : "";
    const template = mailtemplates.find((m: any) => m.eMailType === "BVRA");
    const content = template.eContent
      .replace(mailRegexs.zero + ";", name)
      .replace(mailRegexs.one + ";", "duyệt")
      .replace(mailRegexs.two + ";", vehicleRequest.createdBy.user.displayName)
      .replace(
        mailRegexs.three + ";",
        `${getDDMMYYYFormat(vehicleRequest.createdDateTime)} - ${getHHmmFormat(vehicleRequest.createdDateTime)}`,
      )
      .replace(mailRegexs.siteUrl, url);

    const subject = template.eSubject;
    const message = MailService.buildMailMesssage(subject, content, "html", tomail);
    await MailService.sendMail(message);
  };

  const addVehicleRequest = (officialVehicleRequest: any) => {
    if (id != 0) {
      VehicleRequestService.updateVehicleRequest(id, officialVehicleRequest.fields).then(
        (res) => {
          CreateNotification({
            title: "Thành công",
            body: `Chỉnh sửa yêu cầu thành công.`,
            icon: "/icons/success.png",
          });
          history.push(Routes.officialVehicleDetailPage.path.replace(":id", id));
        },
        (error) => {
          CreateNotification({
            title: "Thất bại",
            body: `Chỉnh sửa yêu cầu thất bại.`,
            icon: "/icons/error.png",
          });
          console.log(error);
        },
      );
    } else {
      VehicleRequestService.addVehicleRequest(officialVehicleRequest).then(
        (res) => {
          CreateNotification({
            title: "Thành công",
            body: `Tạo yêu cầu thành công.`,
            icon: "/icons/success.png",
          });
          if (officialVehicleRequest.fields.eApprovedBy) {
            sendMail(officialVehicleRequest.fields.eApprovedBy, res);
          }
          history.push(Routes.officialVehicleDetailPage.path.replace(":id", res.id));
        },
        (error) => {
          CreateNotification({
            title: "Thất bại",
            body: `Tạo yêu cầu thất bại.`,
            icon: "/icons/error.png",
          });
          console.log(error);
        },
      );
    }
  };

  const onApproverChange = (selectedOptions: any) => {
    setApprover(selectedOptions ? selectedOptions.value : "");
  };

  const onApproverPickerChange = (selectedOptions: any) => {
    setApprover(
      selectedOptions.target.selectedPeople[0]
        ? selectedOptions.target.selectedPeople[0].userPrincipalName.toLowerCase()
        : null,
    );
    setPickedUserName(
      selectedOptions.target.selectedPeople[0]
        ? selectedOptions.target.selectedPeople[0].displayName.toLowerCase()
        : null,
    );
  };

  const getApproverOptions = () => {
    let approvers: any = [];
    if (selectedDepartment && selectedDepartment.id > 0 && selectedUnit) {
      approvers = employees
        .filter((f: any) => eApproveTitleCode.indexOf(f.eBizTitleCode) > -1 && f.eDepartmentCode === selectedUnit.id)
        .map((o: any) => ({
          label: o.Title,
          value: o.eMail,
          default: o.eDefault || false,
        }));
      if (selectedDepartment.id == 1) {
        const tsnHead = isDev
          ? [
              {
                Title: "Phạm Phú Yên",
                eMail: "canbo1@viags.vn",
                eDefault: true,
              },
            ]
          : [
              {
                Title: "Phạm Phú Yên",
                eMail: "yenpp@viags.vn",
                eDefault: true,
              },
              {
                Title: "Nguyễn Vĩnh Hưng",
                eMail: "hungnv@viags.vn",
                eDefault: true,
              },
            ];
        approvers = [...tsnHead];
      }
    } else if (selectedDepartment && selectedDepartment.id != 0)
      approvers = employees
        .filter(
          (f: any) => eApproveTitleCode.indexOf(f.eBizTitleCode) > -1 && f.eDepartmentCode === selectedDepartment.id,
        )
        .map((o: any) => ({
          label: o.Title,
          value: o.eMail,
          default: o.eDefault || false,
        }));

    setApproverOptions(approvers);
    // const defaultApprover = approvers.find((a: any) => a.default);
    // setApprover(defaultApprover.value || approvers[0].value);
  };

  const onDepartmentChange = (selectedOptions: any) => {
    setSelectedDepartment(selectedOptions ? selectedOptions : null);
    if (selectedOptions && typeof selectedOptions.id === "string") setSelectedUnit(selectedOptions);
    setApprover("");
  };

  const onUnitChange = (selectedOptions: any) => {
    setSelectedUnit(selectedOptions ? selectedOptions : null);
    setApprover("");
  };

  useEffect(() => {
    if (selectedDepartment) {
      if (selectedDepartment.id === 2) {
        setUnit(unitNB);
        setSelectedUnit(null);
      } else if (selectedDepartment.id === 3) {
        setUnit(unitDN);
        setSelectedUnit(null);
      } else if (selectedDepartment.id === 1) {
        setUnit(unitTSN);
        setSelectedUnit(null);
      } else {
        setUnit([{ id: selectedDepartment.id, value: selectedDepartment.value }]);
        setSelectedUnit(selectedDepartment);
      }
    }
  }, [selectedDepartment]);

  useEffect(() => {
    if (selectedDepartment) {
      let id = selectedDepartment.id;
      switch (id) {
        case id === 1:
          break;
      }
    }
  }, [selectedDepartment]);

  useEffect(() => {
    if (id != 0) {
      VehicleRequestService.getVehicleRequest(id)
        .then((res) => {
          const { eDescription, eApprovedBy, eRequestType, eContent, eFileContent, ePhoneNumber, eDepartment, eUnit } =
            res.fields;
          const approverEmail = eApprovedBy.split("|")[0];
          setValues({
            description: eDescription,
            requests: JSON.parse(eContent),
            fileRequests: JSON.parse(eFileContent),
            phoneNumber: ePhoneNumber,
          });
          setApprover(approverEmail);
          setRequestType(eRequestType);
          setSelectedDepartment(eDepartment);
          setSelectedUnit(eUnit);
        })
        .catch((error) => console.log(error));
    } else {
      setApprover(employees[0]?.eMail);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    getApproverOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDepartment, selectedUnit]);

  return (
    <div className="ITCodeGrantedCreateNewPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div className="btnBack" onClick={() => history.push(Routes.officialVehicleListPage.path)}>
              <Icon.ArrowLeft />
            </div>
            {id == 0 ? "Tạo Đề Nghị Xin Xe Công Vụ" : "Chỉnh sửa Đề Nghị Xin Xe Công Vụ"}
          </div>
        </div>
        <Col>
          <form onSubmit={handleSubmit}>
            <Box title="Thông tin">
              {id == 0 && (
                <Row>
                  <Col sm="6" md="6">
                    <InputWraper
                      inputProps={getInputProps("deparment")}
                      isRequired
                      renderInput={(s) => (
                        <InputSelect
                          {...s}
                          options={department.map((o: any) => ({
                            id: o.id,
                            label: o.value,
                            value: o.value,
                          }))}
                          value={selectedDepartment}
                          onChange={onDepartmentChange}
                          placeholder="* Chọn Cơ quan/ đơn vị"
                        />
                      )}
                    />
                  </Col>
                  <Col sm="6" md="6">
                    <InputWraper
                      inputProps={getInputProps("unit")}
                      isRequired
                      renderInput={(s) => (
                        <InputSelect
                          {...s}
                          options={unit.map((o: any) => ({
                            id: o.id,
                            label: o.value,
                            value: o.value,
                          }))}
                          value={selectedUnit?.value}
                          onChange={onUnitChange}
                          placeholder={"* Chọn đơn vị"}
                        />
                      )}
                    />
                  </Col>
                </Row>
              )}
              <InputWraper
                inputProps={getInputProps("phoneNumber")}
                renderInput={(s) => <InputNumber {...s} />}
                isRequired
              />
              <InputWraper
                inputProps={getInputProps("description")}
                renderInput={(s) => <InputText {...s} />}
                isRequired
              />
            </Box>

            <Box title="Đề nghị sử dụng xe công vụ theo chi tiết">
              <Row className="px-3">
                <InputWraper
                  className="from__container-input"
                  inputProps={getInputProps("requests")}
                  isRequired
                  renderInput={(state) => (
                    <InputArrayData
                      {...state}
                      // isSelectUnit={selectedUnit ? 1 : 0}
                      // isKeepValue={true}
                      form={VehicleContentForm}
                      structure={VehicleContentStructure}
                      excelTemplate="business-vehicle"
                    />
                  )}
                />
              </Row>

              <InputWraper inputProps={getInputProps("fileRequests")} renderInput={(s) => <Upload {...s} />} />

              {id == 0 && (
                <Row>
                  <Col sm="6" md="6">
                    <InputWraper
                      inputProps={getInputProps("pickApprover")}
                      renderInput={(s) => (
                        <UserSelect
                          {...s}
                          placeholder="Thủ trưởng CQ/ĐV"
                          options={approverOptions}
                          value={approver}
                          onChange={onApproverChange}
                        />
                      )}
                      isRequired
                    />
                  </Col>
                  <Col sm="6" md="6">
                    <InputWraper
                      inputProps={getInputProps("findApprover")}
                      renderInput={(s) => (
                        <div className="people_picker-custom">
                          <PeoplePicker
                            className="people-picker"
                            placeholder="Thủ trưởng CQ/ĐV"
                            type={PersonType.any}
                            selectionChanged={onApproverPickerChange}
                          />
                        </div>
                      )}
                    />
                  </Col>
                </Row>
              )}
            </Box>
            <div className="textRight">
              <Button type="submit" label="Xác nhận" isLoading={isSubmitting} />
              <Button
                type="button"
                label="Huỷ"
                buttonType="grey-outline"
                className="ml10"
                onClick={() => history.push(Routes.officialVehicleListPage.path)}
              />
            </div>
          </form>
        </Col>
      </div>
    </div>
  );
});
